<div class="rounded-corners">
  <table class="mat-mdc-table infoBox">
    <tr class="mat-mdc-header-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell ps-3" [translate]="tableHeader"></th>
      <th class="mat-mdc-header-cell mdc-data-table__header-cell"></th>
    </tr>
    <div class="m-2 ms-3">
      @for (column of displayedColumns; track column) {
        @if (column.columnName !== 'status') {
          <div class="cols-12 row">
            <span class="col-4 text-secondary info subject d-block" translate="Table.{{column.transTag}}"></span>
            <span class="col-8 info text-break">
              {{ tableData[column.columnName] | valueByTypePipe : column.type }}
              <!-- Add copy to clipboard function, based on datatype Guid -->
              @if (column.type === 'Guid' || column.type === 'Hash') {
                <div class="ms-2 copy-icon">
                  <em class="bi bi-copy cursor-pointer " (click)="copyToClipboard(tableData[column.columnName])"></em>
                </div>
              }
            </span>
          </div>
        }
      }
    </div>
  </table>
</div>